<template>
  <v-card>
    <AdCardTitle inline>{{ $t('questionnaire-response') }}</AdCardTitle>
    <div class="px-5 pb-5" v-if="false">
      {{ JSON.stringify(questionnaireActive) }}
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QuestionnaireResponseRenderer',
  components: {
  },
  data () {
    return {
      selectedItem: null
    }
  },
  computed: {
    ...mapGetters('questionnaire', ['questionnaireActive', 'questionnaireItem', 'questionnaireItemIsEditable', 'isLoading']),
    ...mapGetters('app', ['projectLanguage'])
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>

</style>
